// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/data/common/svg/trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editTrackModal {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 460px;
}

.editTrackModal .tabPanels {
  background: var(--modal-bg);
}

.editTrackModalHeader {
  padding: 20px 48px 20px 24px;
  background: var(--modal-bg);
  border-bottom: 1px solid var(--light-border);
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.editTrackModalHeader-sharedAlbum {
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.editTrackModalHeaderArtwork {
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  overflow: hidden;
  border-radius: var(--button-border-radius);
  background: var(--artwork-bg);
}

.editTrackModalHeaderArtwork img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.editTrackModalHeaderArtworkEmpty {
  position: relative;
}

.editTrackModalHeaderArtworkEmpty::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: #00000059;
  mask-position: center;
  mask-size: 36%;
  mask-repeat: no-repeat;
  /* webpackIgnore: true */
  mask-image: url('/svg/music.svg');
}

.editTrackModalHeaderAlbumDetails {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.editTrackModalHeaderTitle {
  margin: 0;
  font-size: var(--modal-header-font-size);
  font-weight: 600;
  color: var(--text-heading);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.editTrackModalHeaderMeta {
  font-size: var(--font-size-small);
  color: var(--text-label);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.editTrackModalGrid {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
  gap: 6px 12px;
}

.editTrackModalDetails {
  padding: 20px 24px;
  background: var(--modal-bg);
}

.editTrackModalIndexNotice {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid var(--primary-color);
  border-radius: var(--button-border-radius);
  background: #eef5ff;
  color: var(--text-body);
  font-size: var(--font-size-small);
}

.editTrackModalIndexNotice-error {
  border-color: var(--error-color);
  background: #fff1f1;
}

.editTrackModalIndexNoticeText {
  line-height: 1.35;
}

.editTrackModalNoticeList {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding-left: 18px;
}

.editTrackModalNoticeList li {
  line-height: 1.35;
}

.editTrackModalNoticePath {
  font-weight: 600;
  margin-right: 6px;
}

.editTrackModalNoticeHelp {
  line-height: 1.35;
}

.editTrackModalIndexNoticeLoading {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.editTrackModalLoadProgress {
  height: 7px;
  overflow: hidden;
  border-radius: 4px;
  background: var(--light-border);
}

.editTrackModalLoadProgressFill {
  height: 100%;
  border-radius: 4px;
  background: var(--primary-color);
  transition: width 120ms linear;
}

.editTrackModalIndexNoticeButton {
  flex-shrink: 0;
  font: inherit;
  color: #fff;
  background: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: var(--button-border-radius);
  padding: 5px 10px;
  cursor: pointer;
}

.editTrackModalIndexNoticeButton:hover {
  background: var(--primary-color-hover);
}

.editTrackModalRow {
  display: contents;
}

.editTrackModalLabel {
  font-size: var(--font-size-small);
  color: var(--text-label);
  font-weight: 500;
  text-align: right;
  white-space: nowrap;
  min-width: 100px;
}

.editTrackModalInput {
  font-size: var(--font-size-small);
  font-family: inherit;
  padding: 5px 8px;
  border: 1px solid var(--light-border);
  border-radius: var(--button-border-radius);
  background: var(--modal-bg);
  color: var(--text-body);
  outline: none;
  width: 100%;
  box-sizing: border-box;
}

.editTrackModalInput:focus {
  border-color: var(--primary-color);
  box-shadow: var(--box-shadow-focus);
}

.editTrackModalRadioGroup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  min-height: 30px;
}

.editTrackModalRadioOption {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-size-small);
  color: var(--text-body);
  white-space: nowrap;
}

.editTrackModalInput-readonly {
  background: var(--surface-raised);
}

.editTrackModalInput-short {
  max-width: 80px;
}

.editTrackModalInput-binary {
  color: var(--text-muted);
  font-style: italic;
}

.editTrackModalGroupHeader {
  grid-column: 1 / -1;
  font-size: var(--font-size-small);
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding-top: 14px;
}

.editTrackModalGroupHeader:first-child {
  padding-top: 0;
}

.editTrackModalSplitInput {
  display: flex;
  align-items: center;
  gap: 6px;
}

.editTrackModalSplitInput-num,
.editTrackModalSplitInput-total {
  width: 60px;
}

.editTrackModalSplitSep {
  font-size: var(--font-size-small);
  color: var(--text-muted);
}

.editTrackModalArtwork {
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: var(--modal-bg);
  min-height: 200px;
}

.editTrackModalArtworkImage {
  max-width: 100%;
  max-height: 320px;
  border-radius: var(--button-border-radius);
  box-shadow: 0 2px 12px #0002;
}

.editTrackModalArtworkEmpty {
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

.editTrackModalTags {
  padding: 0 24px 20px;
  background: var(--modal-bg);
  overflow-y: auto;
}

.editTrackModalTagsFormat {
  font-size: var(--font-size-small);
  color: var(--text-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 16px 0 8px;
}

.editTrackModalTagsLoading {
  padding: 24px 0;
  color: var(--text-muted);
  font-size: var(--font-size-small);
  text-align: center;
}

.editTrackModalTagBinaryCell {
  display: flex;
  gap: 6px;
  align-items: center;
  min-width: 0;
}

.editTrackModalTagBinaryCell .editTrackModalInput {
  flex: 1;
  min-width: 0;
}

.editTrackModalTagLogButton {
  flex-shrink: 0;
  white-space: nowrap;
}

.editTrackModalArtworkSections {
  padding: 20px 24px;
  background: var(--modal-bg);
  display: flex;
  flex-direction: column;
  gap: 28px;
  overflow-y: auto;
}

.artworkBlock {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.artworkBlockLabel {
  font-size: var(--font-size-small);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
}

.artworkChangeBtn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: var(--font-size-small);
  font-family: inherit;
  font-weight: 500;
  padding: 7px 14px;
  border-radius: var(--button-border-radius);
  border: none;
  background: var(--primary-color);
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
}

.artworkChangeBtn:hover:not(:disabled) {
  background: var(--primary-color-hover);
}

.artworkChangeBtn:disabled {
  opacity: 0.55;
  cursor: default;
}

.artworkChangeBtnDanger {
  background: var(--accent-tint);
  color: var(--accent-strong);
}

.artworkChangeBtnDanger:hover:not(:disabled) {
  background: var(--accent-tint);
  box-shadow: inset 0 0 0 1px var(--accent-strong);
}

.artworkChangeBtnDangerConfirm,
.artworkChangeBtnDangerConfirm:hover:not(:disabled) {
  background: var(--accent);
  box-shadow: none;
  color: #fff;
}

.artworkChangeBtnIcon {
  display: block;
}

.artworkSaveFolderBtn {
  font-size: var(--font-size-small);
  font-family: inherit;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--accent-strong);
  cursor: pointer;
  white-space: nowrap;
}

.artworkSaveFolderBtn:hover:not(:disabled) {
  background: var(--accent-tint);
}

.artworkSaveFolderBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

.artworkSectionImage {
  width: 100%;
  max-width: 100%;
  display: block;
  border-radius: 6px;
  border: 1px solid var(--light-border);
}

.artworkSectionImageLoading {
  aspect-ratio: 1 / 1;
  background: var(--artwork-bg);
}

.artworkSectionError {
  font-size: var(--font-size-small);
  color: var(--text-label);
  font-style: italic;
  padding: 8px 0;
}

/* Album artwork: image on the left, metadata and actions on the right. */
.artworkAlbumLayout {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.artworkAlbumImageWrap {
  position: relative;
  flex: 0 0 auto;
  width: 300px;
  max-width: 45%;
}

.artworkAlbumImageWrap.dragging::after {
  content: '';
  position: absolute;
  inset: -4px;
  border: 2px dashed var(--primary-color);
  border-radius: 10px;
  pointer-events: none;
}

.artworkDropOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  text-align: center;
  border-radius: 8px;
  background: #ffffff44;
  backdrop-filter: blur(5px);
  color: var(--ink);
  font-size: 16px;
  font-weight: 600;
  pointer-events: none;
  animation: fadein 120ms ease-out;
}

.artworkAlbumPlaceholder {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  overflow: hidden;
  background: var(--artwork-bg);
}

.artworkAlbumPlaceholder::before {
  content: '';
  position: absolute;
  inset: 0;
  background-color: #00000059;
  mask-position: center;
  mask-size: 36%;
  mask-repeat: no-repeat;
  /* webpackIgnore: true */
  mask-image: url('/svg/music.svg');
}

.artworkAlbumInfo {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.artworkAlbumHeading {
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--text-heading);
}

.artworkMetaLine {
  font-size: var(--font-size-small);
  color: var(--text-label);
}

.artworkPathLink {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  max-width: 100%;
  gap: 5px;
  font-size: var(--font-size-small);
  color: var(--accent-strong);
  text-decoration: underline;
}

.artworkPathLinkText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.artworkPathLinkIcon {
  flex: 0 0 auto;
  display: block;
}

.artworkAlbumActions {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.artworkDivider {
  height: 1px;
  background: var(--light-border);
}

.artworkEmbedBanner {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid var(--light-border);
  border-radius: var(--button-border-radius);
  background: var(--surface-raised);
}

.artworkEmbedBannerHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-small);
  color: var(--text-body);
}

.artworkEmbedBannerInfo {
  display: inline-flex;
  cursor: help;
}

.artworkEmbedBannerIcon {
  flex: 0 0 auto;
  display: block;
  color: var(--text-label);
}

.artworkEmbedBannerButton {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font: inherit;
  font-size: var(--font-size-small);
  font-weight: 500;
  padding: 6px 12px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--accent-strong);
  cursor: pointer;
  white-space: nowrap;
}

.artworkEmbedBannerButton:hover:not(:disabled) {
  background: var(--accent-tint);
}

.artworkEmbedBannerButton:disabled {
  opacity: 0.6;
  cursor: default;
}

.artworkEmbedBannerButtonIcon {
  display: block;
}

.artworkEmbeddedList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.artworkEmbeddedRow {
  border: 1px solid var(--light-border);
  border-radius: var(--button-border-radius);
  overflow: hidden;
}

.artworkEmbeddedRowToggle {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  font: inherit;
  text-align: left;
  background: var(--surface-raised);
  border: none;
  cursor: pointer;
}

.artworkEmbeddedRowToggle:hover {
  background: var(--modal-bg);
}

.artworkEmbeddedChevron {
  flex: 0 0 auto;
  display: block;
  color: var(--text-label);
  transition: transform 120ms ease;
}

.artworkEmbeddedChevron-open {
  transform: rotate(90deg);
}

.artworkEmbeddedThumb {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 4px;
  overflow: hidden;
  background: var(--artwork-bg);
}

.artworkEmbeddedThumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.artworkEmbeddedInfo {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.artworkEmbeddedInfo .artworkMetaLine {
  color: var(--text-body);
}

.artworkEmbeddedSub {
  font-size: var(--font-size-small);
  color: var(--text-label);
}

.artworkEmbeddedExpanded {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: var(--modal-bg);
  border-top: 1px solid var(--light-border);
}

.artworkEmbeddedExpandedActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.artworkEmbeddedRemoveBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-small);
  font-family: inherit;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--accent-strong);
  cursor: pointer;
  white-space: nowrap;
}

.artworkEmbeddedRemoveBtn:hover:not(:disabled) {
  background: var(--accent-tint);
}

.artworkEmbeddedRemoveBtn:disabled {
  opacity: 0.6;
  cursor: default;
}

.artworkEmbeddedRemoveBtnConfirm,
.artworkEmbeddedRemoveBtnConfirm:hover:not(:disabled) {
  border-color: var(--accent);
  background: var(--accent);
  color: #fff;
}

.artworkEmbeddedRemoveBtnIcon {
  display: block;
  width: 14px;
  height: 14px;
  background-color: currentColor;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}

@media (max-width: 520px) {
  .artworkAlbumLayout {
    flex-direction: column;
  }

  .artworkAlbumImageWrap {
    width: 100%;
    max-width: 260px;
  }
}

.editTrackModalFooter {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 24px;
  border-top: 1px solid var(--light-border);
  background: var(--modal-bg);
}

.editTrackModalCloseWarning {
  flex: 1;
  font-size: var(--font-size-small);
  color: var(--text-label);
}

.editTrackModalSaveBtn {
  font-size: var(--font-size-small);
  font-family: inherit;
  padding: 6px 16px;
  border-radius: var(--button-border-radius);
  border: none;
  background: var(--primary-color);
  color: #fff;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
}

.editTrackModalSaveBtn:disabled {
  opacity: 0.45;
  cursor: default;
}

.editTrackModalSaveBtn:hover:not(:disabled) {
  background: var(--primary-color-hover);
}

.artworkItunesSearchBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--font-size-small);
  font-family: inherit;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--accent-strong);
  cursor: pointer;
  white-space: nowrap;
}

.artworkItunesSearchBtn:hover {
  background: var(--accent-tint);
}

.artworkItunesSearchBtnIcon {
  display: block;
}

.artworkItunesSearch {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--light-border);
  border-radius: var(--button-border-radius);
  background: var(--surface-raised);
}

.artworkItunesSearchForm {
  display: flex;
  gap: 8px;
}

.artworkItunesSearchInput {
  flex: 1 1 auto;
  min-width: 0;
  font: inherit;
  font-size: var(--font-size-small);
  padding: 6px 10px;
  border-radius: var(--button-border-radius);
  border: 1px solid var(--light-border);
  background: var(--modal-bg);
  color: var(--text-body);
}

.artworkItunesResultsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
}

.artworkItunesResult {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px;
  border: 1px solid var(--light-border);
  border-radius: var(--button-border-radius);
  background: var(--modal-bg);
  cursor: pointer;
  text-align: left;
  font: inherit;
}

.artworkItunesResult:hover:not(:disabled) {
  border-color: var(--primary-color);
}

.artworkItunesResult:disabled {
  opacity: 0.6;
  cursor: default;
}

.artworkItunesResultImg {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 4px;
  background: var(--artwork-bg);
}

.artworkItunesResultLabel {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: var(--font-size-small);
  color: var(--text-label);
}

.artworkItunesResultOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--button-border-radius);
  background: #00000088;
  color: #fff;
  font-size: var(--font-size-small);
  font-weight: 600;
}

.editTrackModalPathLink {
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: var(--font-size-small);
  color: var(--accent-strong);
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Music/EditTrackModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,sCAAsC;EACtC,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mDAA6C;EAC7C,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,0CAA0C;EAC1C,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qBAAqB;EACrB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B","sourcesContent":[".editTrackModal {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  min-width: 460px;\n}\n\n.editTrackModal .tabPanels {\n  background: var(--modal-bg);\n}\n\n.editTrackModalHeader {\n  padding: 20px 48px 20px 24px;\n  background: var(--modal-bg);\n  border-bottom: 1px solid var(--light-border);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.editTrackModalHeader-sharedAlbum {\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n\n.editTrackModalHeaderArtwork {\n  width: 56px;\n  height: 56px;\n  flex: 0 0 56px;\n  overflow: hidden;\n  border-radius: var(--button-border-radius);\n  background: var(--artwork-bg);\n}\n\n.editTrackModalHeaderArtwork img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.editTrackModalHeaderArtworkEmpty {\n  position: relative;\n}\n\n.editTrackModalHeaderArtworkEmpty::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-color: #00000059;\n  mask-position: center;\n  mask-size: 36%;\n  mask-repeat: no-repeat;\n  /* webpackIgnore: true */\n  mask-image: url('/svg/music.svg');\n}\n\n.editTrackModalHeaderAlbumDetails {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.editTrackModalHeaderTitle {\n  margin: 0;\n  font-size: var(--modal-header-font-size);\n  font-weight: 600;\n  color: var(--text-heading);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.editTrackModalHeaderMeta {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.editTrackModalGrid {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  align-items: center;\n  gap: 6px 12px;\n}\n\n.editTrackModalDetails {\n  padding: 20px 24px;\n  background: var(--modal-bg);\n}\n\n.editTrackModalIndexNotice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border: 1px solid var(--primary-color);\n  border-radius: var(--button-border-radius);\n  background: #eef5ff;\n  color: var(--text-body);\n  font-size: var(--font-size-small);\n}\n\n.editTrackModalIndexNotice-error {\n  border-color: var(--error-color);\n  background: #fff1f1;\n}\n\n.editTrackModalIndexNoticeText {\n  line-height: 1.35;\n}\n\n.editTrackModalNoticeList {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  padding-left: 18px;\n}\n\n.editTrackModalNoticeList li {\n  line-height: 1.35;\n}\n\n.editTrackModalNoticePath {\n  font-weight: 600;\n  margin-right: 6px;\n}\n\n.editTrackModalNoticeHelp {\n  line-height: 1.35;\n}\n\n.editTrackModalIndexNoticeLoading {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.editTrackModalLoadProgress {\n  height: 7px;\n  overflow: hidden;\n  border-radius: 4px;\n  background: var(--light-border);\n}\n\n.editTrackModalLoadProgressFill {\n  height: 100%;\n  border-radius: 4px;\n  background: var(--primary-color);\n  transition: width 120ms linear;\n}\n\n.editTrackModalIndexNoticeButton {\n  flex-shrink: 0;\n  font: inherit;\n  color: #fff;\n  background: var(--primary-color);\n  border: 1px solid var(--primary-color);\n  border-radius: var(--button-border-radius);\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.editTrackModalIndexNoticeButton:hover {\n  background: var(--primary-color-hover);\n}\n\n.editTrackModalRow {\n  display: contents;\n}\n\n.editTrackModalLabel {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n  font-weight: 500;\n  text-align: right;\n  white-space: nowrap;\n  min-width: 100px;\n}\n\n.editTrackModalInput {\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  padding: 5px 8px;\n  border: 1px solid var(--light-border);\n  border-radius: var(--button-border-radius);\n  background: var(--modal-bg);\n  color: var(--text-body);\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.editTrackModalInput:focus {\n  border-color: var(--primary-color);\n  box-shadow: var(--box-shadow-focus);\n}\n\n.editTrackModalRadioGroup {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  min-height: 30px;\n}\n\n.editTrackModalRadioOption {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: var(--font-size-small);\n  color: var(--text-body);\n  white-space: nowrap;\n}\n\n.editTrackModalInput-readonly {\n  background: var(--surface-raised);\n}\n\n.editTrackModalInput-short {\n  max-width: 80px;\n}\n\n.editTrackModalInput-binary {\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n.editTrackModalGroupHeader {\n  grid-column: 1 / -1;\n  font-size: var(--font-size-small);\n  color: var(--text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding-top: 14px;\n}\n\n.editTrackModalGroupHeader:first-child {\n  padding-top: 0;\n}\n\n.editTrackModalSplitInput {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.editTrackModalSplitInput-num,\n.editTrackModalSplitInput-total {\n  width: 60px;\n}\n\n.editTrackModalSplitSep {\n  font-size: var(--font-size-small);\n  color: var(--text-muted);\n}\n\n.editTrackModalArtwork {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  background: var(--modal-bg);\n  min-height: 200px;\n}\n\n.editTrackModalArtworkImage {\n  max-width: 100%;\n  max-height: 320px;\n  border-radius: var(--button-border-radius);\n  box-shadow: 0 2px 12px #0002;\n}\n\n.editTrackModalArtworkEmpty {\n  color: var(--text-muted);\n  font-size: var(--font-size-small);\n}\n\n.editTrackModalTags {\n  padding: 0 24px 20px;\n  background: var(--modal-bg);\n  overflow-y: auto;\n}\n\n.editTrackModalTagsFormat {\n  font-size: var(--font-size-small);\n  color: var(--text-muted);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 16px 0 8px;\n}\n\n.editTrackModalTagsLoading {\n  padding: 24px 0;\n  color: var(--text-muted);\n  font-size: var(--font-size-small);\n  text-align: center;\n}\n\n.editTrackModalTagBinaryCell {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  min-width: 0;\n}\n\n.editTrackModalTagBinaryCell .editTrackModalInput {\n  flex: 1;\n  min-width: 0;\n}\n\n.editTrackModalTagLogButton {\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.editTrackModalArtworkSections {\n  padding: 20px 24px;\n  background: var(--modal-bg);\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  overflow-y: auto;\n}\n\n.artworkBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.artworkBlockLabel {\n  font-size: var(--font-size-small);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text-muted);\n}\n\n.artworkChangeBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  font-weight: 500;\n  padding: 7px 14px;\n  border-radius: var(--button-border-radius);\n  border: none;\n  background: var(--primary-color);\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.artworkChangeBtn:hover:not(:disabled) {\n  background: var(--primary-color-hover);\n}\n\n.artworkChangeBtn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.artworkChangeBtnDanger {\n  background: var(--accent-tint);\n  color: var(--accent-strong);\n}\n\n.artworkChangeBtnDanger:hover:not(:disabled) {\n  background: var(--accent-tint);\n  box-shadow: inset 0 0 0 1px var(--accent-strong);\n}\n\n.artworkChangeBtnDangerConfirm,\n.artworkChangeBtnDangerConfirm:hover:not(:disabled) {\n  background: var(--accent);\n  box-shadow: none;\n  color: #fff;\n}\n\n.artworkChangeBtnIcon {\n  display: block;\n}\n\n.artworkSaveFolderBtn {\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--accent-strong);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.artworkSaveFolderBtn:hover:not(:disabled) {\n  background: var(--accent-tint);\n}\n\n.artworkSaveFolderBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.artworkSectionImage {\n  width: 100%;\n  max-width: 100%;\n  display: block;\n  border-radius: 6px;\n  border: 1px solid var(--light-border);\n}\n\n.artworkSectionImageLoading {\n  aspect-ratio: 1 / 1;\n  background: var(--artwork-bg);\n}\n\n.artworkSectionError {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n  font-style: italic;\n  padding: 8px 0;\n}\n\n/* Album artwork: image on the left, metadata and actions on the right. */\n.artworkAlbumLayout {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.artworkAlbumImageWrap {\n  position: relative;\n  flex: 0 0 auto;\n  width: 300px;\n  max-width: 45%;\n}\n\n.artworkAlbumImageWrap.dragging::after {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  border: 2px dashed var(--primary-color);\n  border-radius: 10px;\n  pointer-events: none;\n}\n\n.artworkDropOverlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  text-align: center;\n  border-radius: 8px;\n  background: #ffffff44;\n  backdrop-filter: blur(5px);\n  color: var(--ink);\n  font-size: 16px;\n  font-weight: 600;\n  pointer-events: none;\n  animation: fadein 120ms ease-out;\n}\n\n.artworkAlbumPlaceholder {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  border-radius: 8px;\n  overflow: hidden;\n  background: var(--artwork-bg);\n}\n\n.artworkAlbumPlaceholder::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-color: #00000059;\n  mask-position: center;\n  mask-size: 36%;\n  mask-repeat: no-repeat;\n  /* webpackIgnore: true */\n  mask-image: url('/svg/music.svg');\n}\n\n.artworkAlbumInfo {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.artworkAlbumHeading {\n  font-size: var(--font-size-small);\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n.artworkMetaLine {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n}\n\n.artworkPathLink {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  max-width: 100%;\n  gap: 5px;\n  font-size: var(--font-size-small);\n  color: var(--accent-strong);\n  text-decoration: underline;\n}\n\n.artworkPathLinkText {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.artworkPathLinkIcon {\n  flex: 0 0 auto;\n  display: block;\n}\n\n.artworkAlbumActions {\n  margin-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.artworkDivider {\n  height: 1px;\n  background: var(--light-border);\n}\n\n.artworkEmbedBanner {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px;\n  border: 1px solid var(--light-border);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-raised);\n}\n\n.artworkEmbedBannerHeader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--font-size-small);\n  color: var(--text-body);\n}\n\n.artworkEmbedBannerInfo {\n  display: inline-flex;\n  cursor: help;\n}\n\n.artworkEmbedBannerIcon {\n  flex: 0 0 auto;\n  display: block;\n  color: var(--text-label);\n}\n\n.artworkEmbedBannerButton {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font: inherit;\n  font-size: var(--font-size-small);\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--accent-strong);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.artworkEmbedBannerButton:hover:not(:disabled) {\n  background: var(--accent-tint);\n}\n\n.artworkEmbedBannerButton:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.artworkEmbedBannerButtonIcon {\n  display: block;\n}\n\n.artworkEmbeddedList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.artworkEmbeddedRow {\n  border: 1px solid var(--light-border);\n  border-radius: var(--button-border-radius);\n  overflow: hidden;\n}\n\n.artworkEmbeddedRowToggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 12px;\n  font: inherit;\n  text-align: left;\n  background: var(--surface-raised);\n  border: none;\n  cursor: pointer;\n}\n\n.artworkEmbeddedRowToggle:hover {\n  background: var(--modal-bg);\n}\n\n.artworkEmbeddedChevron {\n  flex: 0 0 auto;\n  display: block;\n  color: var(--text-label);\n  transition: transform 120ms ease;\n}\n\n.artworkEmbeddedChevron-open {\n  transform: rotate(90deg);\n}\n\n.artworkEmbeddedThumb {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--artwork-bg);\n}\n\n.artworkEmbeddedThumb img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.artworkEmbeddedInfo {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.artworkEmbeddedInfo .artworkMetaLine {\n  color: var(--text-body);\n}\n\n.artworkEmbeddedSub {\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n}\n\n.artworkEmbeddedExpanded {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: var(--modal-bg);\n  border-top: 1px solid var(--light-border);\n}\n\n.artworkEmbeddedExpandedActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.artworkEmbeddedRemoveBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--accent-strong);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.artworkEmbeddedRemoveBtn:hover:not(:disabled) {\n  background: var(--accent-tint);\n}\n\n.artworkEmbeddedRemoveBtn:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.artworkEmbeddedRemoveBtnConfirm,\n.artworkEmbeddedRemoveBtnConfirm:hover:not(:disabled) {\n  border-color: var(--accent);\n  background: var(--accent);\n  color: #fff;\n}\n\n.artworkEmbeddedRemoveBtnIcon {\n  display: block;\n  width: 14px;\n  height: 14px;\n  background-color: currentColor;\n  mask-image: url('/data/common/svg/trash.svg');\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: contain;\n}\n\n@media (max-width: 520px) {\n  .artworkAlbumLayout {\n    flex-direction: column;\n  }\n\n  .artworkAlbumImageWrap {\n    width: 100%;\n    max-width: 260px;\n  }\n}\n\n.editTrackModalFooter {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 12px 24px;\n  border-top: 1px solid var(--light-border);\n  background: var(--modal-bg);\n}\n\n.editTrackModalCloseWarning {\n  flex: 1;\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n}\n\n.editTrackModalSaveBtn {\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  padding: 6px 16px;\n  border-radius: var(--button-border-radius);\n  border: none;\n  background: var(--primary-color);\n  color: #fff;\n  cursor: pointer;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.editTrackModalSaveBtn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.editTrackModalSaveBtn:hover:not(:disabled) {\n  background: var(--primary-color-hover);\n}\n\n.artworkItunesSearchBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--font-size-small);\n  font-family: inherit;\n  font-weight: 500;\n  padding: 6px 12px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--primary-color);\n  background: transparent;\n  color: var(--accent-strong);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.artworkItunesSearchBtn:hover {\n  background: var(--accent-tint);\n}\n\n.artworkItunesSearchBtnIcon {\n  display: block;\n}\n\n.artworkItunesSearch {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px;\n  border: 1px solid var(--light-border);\n  border-radius: var(--button-border-radius);\n  background: var(--surface-raised);\n}\n\n.artworkItunesSearchForm {\n  display: flex;\n  gap: 8px;\n}\n\n.artworkItunesSearchInput {\n  flex: 1 1 auto;\n  min-width: 0;\n  font: inherit;\n  font-size: var(--font-size-small);\n  padding: 6px 10px;\n  border-radius: var(--button-border-radius);\n  border: 1px solid var(--light-border);\n  background: var(--modal-bg);\n  color: var(--text-body);\n}\n\n.artworkItunesResultsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 10px;\n}\n\n.artworkItunesResult {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 6px;\n  border: 1px solid var(--light-border);\n  border-radius: var(--button-border-radius);\n  background: var(--modal-bg);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n}\n\n.artworkItunesResult:hover:not(:disabled) {\n  border-color: var(--primary-color);\n}\n\n.artworkItunesResult:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.artworkItunesResultImg {\n  display: block;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n  border-radius: 4px;\n  background: var(--artwork-bg);\n}\n\n.artworkItunesResultLabel {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  font-size: var(--font-size-small);\n  color: var(--text-label);\n}\n\n.artworkItunesResultOverlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--button-border-radius);\n  background: #00000088;\n  color: #fff;\n  font-size: var(--font-size-small);\n  font-weight: 600;\n}\n\n.editTrackModalPathLink {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-size: var(--font-size-small);\n  color: var(--accent-strong);\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
